import _ from 'lodash';
import { FileGallery, permissions, Debug, Comment } from '~';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';
import { CAMPAIGN_TYPES, CREATIVE_STATUSES, COMMENTABLE_TYPES } from '@/util/constants';
import CreativePreviewFeedback from '@/components/creative-preview-feedback/CreativePreviewFeedback.vue';
import { mapGetters, mapActions } from 'vuex';
import Creative from './creative/Creative.vue';

const debug = Debug('campaign-creatives');

export default {
  components: {
    'box-widget': BoxWidget,
    creative: Creative,
    'file-gallery': FileGallery,
    'creative-preview-feedback': CreativePreviewFeedback,
    comment: Comment,
  },
  computed: {
    ...mapGetters('campaign', {
      campaign: 'currentCampaign',
    }),
    creatives() {
      return this.campaign.creatives !== null ? this.campaign.creatives : [];
    },
    facebookPage() {
      return this.campaign.fbpage;
    },
    readyForCAP() {
      return _.get(this.campaign, 'ready_for_cap.creatives', false) ? 'success' : 'error';
    },
    canActAsCustomer() {
      return true;
    },
    permissions() {
      return permissions;
    },
  },
  methods: {
    ...mapActions('creative', ['moveForward', 'moveBack']),
    ...mapActions('campaign', ['reloadCampaign']),
    isExternalCreative(creative) {
      return _.get(creative, 'type', null) === CAMPAIGN_TYPES.EXTERNAL;
    },
    thumbnailIcon(file) {
      const ext = this.getFileExtenstion(file.file_name);
      const icons = ['xlsx', 'xls', 'pdf', 'csv', 'txt'];
      return _.includes(icons, ext);
    },
    getFileExtenstion(filename) {
      return filename.split('.').pop().toLowerCase();
    },
    getCreativeExternalPreviews(creative) {
      return _.get(creative, 'external_previews', []).map(p => ({
        ...p,
        href: this.thumbnailIcon(p) ? p.thumbnail : p.path,
        type: p.content_type,
      }));
    },
    edit(creativeId) {
      this.$router.push({
        name: 'creative',
        params: { id: creativeId },
      });
    },
    isCreativeReady(creative) {
      return creative.status === CREATIVE_STATUSES.READY;
    },
    commentData(creative) {
      return {
        commentable_id: creative.id,
        commentable_type: COMMENTABLE_TYPES.CREATIVE,
      };
    },
    approveCreative(creative) {
      return this.moveForward(creative.id)
        .then(() => this.$toast.info({ message: this.$t('pos.creative.creative-next') }))
        .then(() => this.reloadCampaign())
        .catch(e => debug('error in finish()', e));
    },
    rejectCreative(creative) {
      return this.moveBack({
        id: creative.id,
        data: this.$refs[`comment-reject-${creative.id}`][0].getCommentData(),
      })
        .then(() => {
          if (this.$refs[`comment-reject-${creative.id}`][0]) {
            this.$refs[`comment-reject-${creative.id}`][0].clearCommentData();
          }
          this.$toast.info({ message: this.$t('pos.creative.creative-rejected') });
          return this.reloadCampaign();
        })
        .catch(e => {
          this.$toast.error({ message: e.toString() });
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaign-creatives/CampaignCreatives.js